module.exports = __webpack_public_path__ + "assets/img/W-1-F.cb1ce1b4.png";